import { IntlShape } from "react-intl";
import { StopAddressType, StopTimeType } from "types/MultiStop";

export const cargoReadyPickupOption = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "new-request.schedule.cargoReadyPickupOption.after", defaultMessage: "After" }),
    value: "after",
  },
  {
    label: intl.formatMessage({ id: "new-request.schedule.cargoReadyPickupOption.between", defaultMessage: "Between" }),
    value: "between",
  },
];

export const cargoReadyDeliveryOption = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.before",
      defaultMessage: "Before",
    }),
    value: "before",
  },
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.between",
      defaultMessage: "Between",
    }),
    value: "between",
  },
];

export const pickupDeliveryOption = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "general.address", defaultMessage: "Address" }),
    value: "address",
  },
  {
    value: "airport",
    label: intl.formatMessage({ id: "general.airport", defaultMessage: "Airport" }),
  },
  {
    value: "seaport",
    label: intl.formatMessage({ id: "general.port", defaultMessage: "Port" }),
  },
];

export const notifyPartyOption = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.schedule.notifyParty.customAddressContact",
      defaultMessage: "Custom address & contact",
    }),
    value: "customAddressContact",
  },
  {
    label: intl.formatMessage({
      id: "new-request.schedule.sameAsConsigneeAddressContact",
      defaultMessage: "Same as consignee address & consignee contact",
    }),
    value: "sameAsConsigneeAddressContact",
  },
  {
    label: intl.formatMessage({
      id: "new-request.schedule.sameAsDeliveryAddressContact",
      defaultMessage: "Same as delivery address & delivery contact",
    }),
    value: "sameAsDeliveryAddressContact",
  },
];

export const SERVICE_LEVEL_OPTIONS = (intl: IntlShape) => [
  {
    value: "",
    label: intl.formatMessage({
      id: "new-request.schedule.selectServiceLevel",
      defaultMessage: "Select a service level",
    }),
  },
  {
    value: "1",
    label: intl.formatMessage({
      id: "new-request.schedule.selectServiceLevel1Day",
      defaultMessage: "1 day",
    }),
  },
  {
    value: "3",
    label: intl.formatMessage({
      id: "new-request.schedule.selectServiceLevel3Day",
      defaultMessage: "3 day",
    }),
  },
  {
    value: "5",
    label: intl.formatMessage({
      id: "new-request.schedule.selectServiceLevel5Day",
      defaultMessage: "5 day",
    }),
  },
  {
    value: "7",
    label: intl.formatMessage({
      id: "new-request.schedule.selectServiceLevel7Day",
      defaultMessage: "7 day",
    }),
  },
  {
    value: "NA",
    label: intl.formatMessage({
      id: "new-request.schedule.selectServiceLevelNA",
      defaultMessage: "Not Applicable - E.g. for Ocean freight",
    }),
  },
];

export const miniTenderScheduleDefaultValues = {
  pickup_cargo_ready: "unspecified",
  delivery_cargo_ready: "unspecified",
  pickup_ready_date: null,
  pickup_ready_time: null,
  stop1_after_date: null,
  stop1_after_time: null,
};

// === MultiDrop options start ===
export const multiDropPickupTimeTypeOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "new-request.schedule.cargoReadyPickupOption.after", defaultMessage: "After" }),
    value: StopTimeType.AFTER,
  },
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.between",
      defaultMessage: "Between",
    }),
    value: StopTimeType.BETWEEN,
  },
];

export const multiDropDeliveryTimeTypeOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.before",
      defaultMessage: "Before",
    }),
    value: StopTimeType.BEFORE,
  },
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.between",
      defaultMessage: "Between",
    }),
    value: StopTimeType.BETWEEN,
  },
];
// === MultiDrop options end ===

// === MultiStop options start ===
export const multiStopPickupTimeTypeOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "new-request.schedule.cargoReadyPickupOption.after", defaultMessage: "After" }),
    value: StopTimeType.AFTER,
  },
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.between",
      defaultMessage: "Between",
    }),
    value: StopTimeType.BETWEEN,
  },
];

export const multiStopDeliveryTimeTypeOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.before",
      defaultMessage: "Before",
    }),
    value: StopTimeType.BEFORE,
  },
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.between",
      defaultMessage: "Between",
    }),
    value: StopTimeType.BETWEEN,
  },
];

export const asapDeliveryOption = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.schedule.defaultCargoReadyDeliveryOption.asap",
      defaultMessage: "ASAP Delivery",
    }),
    value: StopTimeType.ASAP_DELIVERY,
  },
];

export const multiStopPickupDeliveryOption = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "general.address", defaultMessage: "Address" }),
    value: StopAddressType.ADDRESS,
  },
  {
    label: intl.formatMessage({ id: "general.airport", defaultMessage: "Airport" }),
    value: StopAddressType.AIRPORT,
  },
  {
    label: intl.formatMessage({ id: "general.port", defaultMessage: "Port" }),
    value: StopAddressType.SEAPORT,
  },
];
// === MultiStop options end ===
